var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 14.741a4 4 0 011.589-3.191l9.125-6.895a4 4 0 014.822 0l9.125 6.895a4 4 0 011.589 3.191v13.592c0 .752-.307 1.473-.854 2.004a2.96 2.96 0 01-2.063.83H7.292a2.96 2.96 0 01-2.063-.83 2.793 2.793 0 01-.854-2.004V14.741z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 31.167V17h8.75v14.167",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzUgMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00LjM3NSAxNC43NDEyQzQuMzc1IDEzLjQ4NzEgNC45NjMxMSAxMi4zMDU3IDUuOTYzNjcgMTEuNTQ5N0wxNS4wODg3IDQuNjU1MjdDMTYuNTE1NSAzLjU3NzIzIDE4LjQ4NDUgMy41NzcyMyAxOS45MTEzIDQuNjU1MjdMMjkuMDM2MyAxMS41NDk3QzMwLjAzNjkgMTIuMzA1NyAzMC42MjUgMTMuNDg3MSAzMC42MjUgMTQuNzQxMlYyOC4zMzM0QzMwLjYyNSAyOS4wODQ4IDMwLjMxNzcgMjkuODA1NSAyOS43NzA3IDMwLjMzNjhDMjkuMjIzNyAzMC44NjgyIDI4LjQ4MTkgMzEuMTY2NyAyNy43MDgzIDMxLjE2NjdINy4yOTE2N0M2LjUxODEyIDMxLjE2NjcgNS43NzYyNSAzMC44NjgyIDUuMjI5MjcgMzAuMzM2OEM0LjY4MjI5IDI5LjgwNTUgNC4zNzUgMjkuMDg0OCA0LjM3NSAyOC4zMzM0VjE0Ljc0MTJaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuMTI1IDMxLjE2NjdWMTdIMjEuODc1VjMxLjE2NjciIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgHouse as ReactComponent };